import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46ae37a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-footer" }
const _hoisted_2 = { class: "section-one-the-pl" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " 캠페인 문의 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " 카카오톡 채널 [원더플 캠페인] 을 검색해주세요. ", -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " 운영 시간 : 평일 오전 10시 ~ 오후 6시 (주말 및 공휴일 제외) ", -1))
const _hoisted_7 = { class: "container-brand" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "section-brand" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "section-cocacola" }
const _hoisted_13 = ["src"]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const logos = [
    {
      link: 'https://www.coca-cola.co.kr',
      image: require('./images/img_logo_cocacola.png')
    },
    {
      link: 'https://www.byn.kr/blackyak',
      image: require('./images/img_logo_blackyak.png')
    },
    {
      link: 'https://company.emart.com/ko/ethic/outline.do',
      image: require('./images/img_logo_emart.png')
    },
    {
      link: 'https://www.ssg.com',
      image: require('./images/img_logo_ssg.png')
    },
    {
      link: 'https://www.gmarket.co.kr',
      image: require('./images/img_logo_gmarket.png')
    },
    {
      link: 'http://www.auction.co.kr',
      image: require('./images/img_logo_auction.png')
    },
    {
      link: 'http://www.wwfkorea.or.kr',
      image: require('./images/img_logo_wwf.png')
    },
    {
      link: 'https://www.terracycle-kr.com',
      image: require('./images/img_logo_terracycle.png')
    },
  ];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("img", {
        src: require('./images/one-the-pl.png')
      }, null, 8, _hoisted_5),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("section", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(logos, (item, index) => {
            return _createElementVNode("a", {
              key: index,
              class: "item",
              href: item.link,
              target: "_blank"
            }, [
              _createElementVNode("img", {
                src: item.image
              }, null, 8, _hoisted_11)
            ], 8, _hoisted_10)
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("img", {
        src: require('./images/brand.png')
      }, null, 8, _hoisted_13)
    ])
  ]))
}
}

})